var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStepItem3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icono / Outlined / Numbers") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.0654,12 C1.0654,5.925 5.9894,1 12.0654,1 C18.1394,1 23.0654,5.925 23.0654,12 C23.0654,18.075 18.1404,23 12.0654,23 C5.9904,23 1.0654,18.075 1.0654,12 Z M3.0654,12 C3.0654,16.9704545 7.09494545,21 12.0654,21 C17.0358545,21 21.0654,16.9704545 21.0654,12 C21.0654,7.02954545 17.0350364,3 12.0654,3 C7.09412727,3 3.0654,7.02954545 3.0654,12 Z M13.2465,11.131 C13.9831703,11.2350005 14.5746644,11.5058311 15.021,11.9435 C15.4673356,12.3811689 15.6905,12.9423299 15.6905,13.627 C15.6905,14.2076696 15.5388348,14.7233311 15.2355,15.174 C14.9321651,15.6246689 14.5031694,15.9756654 13.9485,16.227 C13.3938306,16.4783346 12.7438371,16.604 11.9985,16.604 C11.3311633,16.604 10.6746699,16.5021677 10.029,16.2985 C9.3833301,16.0948323 8.83950221,15.8240017 8.3975,15.486 L9.2815,13.809 C9.66283524,14.1296683 10.0701645,14.3723325 10.5035,14.537 C10.9368355,14.7016675 11.3701645,14.784 11.8035,14.784 C12.3061692,14.784 12.691832,14.686501 12.9605,14.4915 C13.229168,14.296499 13.3635,14.0170018 13.3635,13.653 C13.3635,13.2889982 13.229168,13.0116676 12.9605,12.821 C12.691832,12.6303324 12.3018359,12.535 11.7905,12.535 L10.2565,12.535 L10.2565,11.235 L12.3625,9.207 L8.8785,9.207 L8.8785,7.387 L15.2485,7.387 L15.2485,8.765 L12.7655,11.04 L13.2465,11.131 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icono-/-Outlined-/-Numbers",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Black-/-400",
    mask: "url(#mask-2)",
    fill: "#848484"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepItem3);
export default __webpack_public_path__ + "static/media/step-item-3.0e1a37436509d12626bb43a8e77f04bb.svg";
export { ForwardRef as ReactComponent };